// De originele trendkaart voor kaart in kaart (huisregel 4, nieuw/kaartlaag.tsx).
// Klik je in een paneel op een trend, dan legt de kaartlaag deze kaart erover:
// dezelfde kop, inhoud en voet als het paneel op de Trends-pagina
// (trendKop · TrendInhoud · trendVoet uit TrendPaneel.tsx), geen kleinere
// versie. De trend komt live binnen met GET /api/trends/{id}.

import { api } from "../../lib/api";
import { useResource } from "../../lib/useResource";
import { LaadRegels, LegeStaat } from "../../stijl";
import { type KaartComponent, registreerKaart } from "../kaartlaag";
import { titel as trendTitel } from "./data";
import { TrendInhoud, trendKop, trendVoet } from "./TrendPaneel";
import { trendlaagAan } from "../trendlaag/schakelaar";
import { BevindingLader, LaagTrendLader } from "../trendlaag/kaart";

// Met de trendlaag (schakelaar aan) opent elke trendlink de trendlaag-kaart: de
// bevinding wordt via /trendlaag/van vertaald naar zijn trend (M1: in één keer).
export const TrendKaart: KaartComponent = ({ id, titel, toon }) =>
  trendlaagAan() ? <VanBevinding id={id} titel={titel} toon={toon} /> : <TrendKaartLader id={id} titel={titel} toon={toon} />;

function VanBevinding({ id, titel, toon }: Parameters<KaartComponent>[0]) {
  const r = useResource(() => api.trendlaagVan(id), [id]);
  if (r.data?.trendId) return <LaagTrendLader id={r.data.trendId} titel={titel} toon={toon} />;
  // Een niet-ingedeelde bevinding (trendId null) of een fout: het oude detail
  // van die bevinding, zoals ChatLaagTrend; anders bleef dit eindeloos laden.
  if (r.error || (r.data && !r.data.trendId)) return <TrendKaartLader id={id} titel={titel} toon={toon} />;
  return toon({ label: titel ?? "Trend", kop: <span className="s-meta">Trend</span>, inhoud: <LaadRegels regels={4} zin="Trend laden…" /> });
}

function TrendKaartLader({ id, titel, toon }: Parameters<KaartComponent>[0]) {
  const r = useResource(() => api.trend(id), [id]);
  const t = r.data?.trend ?? null;
  return toon({
    label: t ? trendTitel(t) : (titel ?? "Trend"),
    kop: t ? trendKop(t) : <span className="s-meta t-paneel__soort">Trend</span>,
    inhoud: t ? (
      <TrendInhoud key={t.id} trend={t} />
    ) : r.error ? (
      <LegeStaat zin={`De trend kon niet worden opgehaald: ${r.error}`} actie="Opnieuw proberen" onActie={r.reload} />
    ) : (
      <LaadRegels regels={4} zin="Trend laden…" />
    ),
    voet: t ? trendVoet(t) : undefined,
  });
}

registreerKaart("trend", TrendKaart);
// De trendlaag (Waarom nu-regels in het trendpaneel): één bevinding opent haar
// eigen kaart, ook met de schakelaar aan (anders vertaalt /van haar terug naar
// dezelfde trend). Met de schakelaar aan leest ze de lichte route
// /trendlaag/bevinding: /trends/{id} toont alleen gepubliceerde bevindingen en
// gaf bij de waarom-nu-kandidaten 404. Uit = de oude trendkaart.
registreerKaart("bevinding", ({ id, titel, toon }) =>
  trendlaagAan() ? <BevindingLader id={id} titel={titel} toon={toon} /> : <TrendKaartLader id={id} titel={titel} toon={toon} />,
);
